/**
 * Utility function whose advantage is that it accepts any value, not just `string`, and it returns `undefined` if the
 * result of parsing the value is `NaN`, allowing for one-liners using `??` chaining.
 * ```
 * const dangerousValue: any = 'whatever';
 * const value = parseNumber(dangerousValue) ?? 0; // cannot be done with Number.parseFloat(value) | Number(value)
 * ```
 * @param value
 * @param asInt
 */
export function parseNumber(value: any, asInt: boolean = false) {
	const parsed = asInt ? Number.parseInt(value) : Number.parseFloat(value);

	if (Number.isNaN(parsed)) {
		return undefined;
	}

	return parsed;
}
